import { createContext, useContext, useState, ReactNode } from 'react'
import { Theme } from '@/types/theme'

interface ThemeContextValue {
  themeConfig: Theme
  setThemeConfig: (theme: Theme) => void
}

const ThemeContext = createContext<ThemeContextValue | null>(null)

export function ThemeConfigProvider({
  children,
  initialTheme
}: {
  children: ReactNode
  initialTheme: Theme
}) {

  const [themeConfig, setThemeConfig] = useState(initialTheme)

  return (
    <ThemeContext.Provider value={{ themeConfig, setThemeConfig }}>
      {children}
    </ThemeContext.Provider>
  )
}

export const useThemeConfig = () => {
  const ctx = useContext(ThemeContext)
  if (!ctx) throw new Error('useTheme must be used inside ThemeProvider')
  return ctx
}
